export type ThemeMode = 'light' | 'dark'

export function applyTheme(theme: ThemeMode): void {
  const html = document.documentElement
  const suffix = theme === 'dark' ? 'dark' : 'light'

  html.style.setProperty('--color-primary', `var(--color-primary-${suffix})`)
  html.style.setProperty('--color-secondary', `var(--color-secondary-${suffix})`)
  html.style.setProperty('--color-accent', `var(--color-accent-${suffix})`)
  html.style.setProperty('--color-neutral', `var(--color-neutral-${suffix})`)
  html.style.setProperty('--color-surface', `var(--color-surface-${suffix})`)
  html.style.setProperty('--color-on-surface', `var(--color-on-surface-${suffix})`)
  html.style.setProperty(
    '--color-on-surface-secondary',
    `var(--color-on-surface-secondary-${suffix})`,
  )
  html.style.setProperty('--color-on-primary', `var(--color-on-primary-${suffix})`)
  html.style.setProperty(
    '--color-surface-elevated',
    `var(--color-surface-elevated-${suffix})`,
  )
  html.style.setProperty(
    '--color-on-secondary',
    `var(--color-on-secondary-${suffix})`,
  )
  html.style.setProperty('--color-on-accent', `var(--color-on-accent-${suffix})`)
  html.style.setProperty('--color-border', `var(--color-border-${suffix})`)
  html.style.setProperty('--color-outline', `var(--color-outline-${suffix})`)
  html.style.setProperty('--color-overlay', `var(--color-overlay-${suffix})`)
  html.style.setProperty('--color-backplate', `var(--color-backplate-${suffix})`)
  html.style.setProperty('--color-scrim', `var(--color-scrim-${suffix})`)

  html.setAttribute('data-theme', theme)
  try {
    localStorage.setItem('theme', theme)
  } catch {
    /* ignore */
  }
}

export function readStoredTheme(): ThemeMode {
  try {
    const s = localStorage.getItem('theme')
    if (s === 'dark' || s === 'light') return s
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
  }
  return 'light'
}
